const API_KEY = '74ec522cb933c995f0624f8e89b34cbf'

export default API_KEY

